// @flow

import {
  ForecastMetricAlternate,
  ForecastMetricTitleGroup,
  MetricLabel
} from "./ForecastMetric"

import type { Pollutant } from "./types"

import CurrentAirQualityView from "./CurrentAirQualityView"

export default CurrentAirQualityView

export { ForecastMetricAlternate, ForecastMetricTitleGroup, MetricLabel }

export type { Pollutant }



// WEBPACK FOOTER //
// ./src/Kiosk/CurrentAirQualityView/index.js